const scheduleRoutes = [
    {
        path: '/schedule',
        name: 'schedule',
        component: () => import('@/views/schedule/Schedule'),
    }
]
export default scheduleRoutes